import OktaAuth, { AccessToken } from '@okta/okta-auth-js';
import { useEffect } from 'react';

const hasTokenExpired = (accessToken: AccessToken, expiredTimeOffSetInMs: number) => {
  const currentTimeInMs = Date.now();
  const timeToEvaluatedExpiry = currentTimeInMs - expiredTimeOffSetInMs;
  const expiredAtInMS = accessToken.expiresAt * 1_000;
  return expiredAtInMS <= timeToEvaluatedExpiry;
};

export const useCheckHasExpired = (
  expiredIntervalInMs: number,
  oktaAuth: OktaAuth,
  callback: () => void,
) => {
  useEffect(() => {
    const interval = setInterval(() => {
      const authState = oktaAuth.authStateManager.getAuthState();
      const accessToken: AccessToken | undefined = authState?.accessToken;

      if (!accessToken) {
        return; // we cant check a token that is not yet retrieved.
      }

      if (hasTokenExpired(accessToken, expiredIntervalInMs)) {
        callback();
      }
    }, expiredIntervalInMs);
    return () => clearInterval(interval);
  }, [callback]);
};
